import component from '@/mixins/component'

export default {
  name: 'push-link',
  mixins: [component],
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
